import request from '@/utils/request'


// 查询工资模板列表
export function listSalary(query) {
  return request({
    url: '/user/salary-head/list',
    method: 'get',
    params: query
  })
}

// 查询工资模板分页
export function pageSalary(query) {
  return request({
    url: '/user/salary-head/page',
    method: 'get',
    params: query
  })
}

// 查询工资模板详细
export function getSalary(data) {
  return request({
    url: '/user/salary-head/detail',
    method: 'get',
    params: data
  })
}

// 新增工资模板
export function addSalary(data) {
  return request({
    url: '/user/salary-head/add',
    method: 'post',
    data: data
  })
}

// 修改工资模板
export function updateSalary(data) {
  return request({
    url: '/user/salary-head/edit',
    method: 'post',
    data: data
  })
}

export function approve(data) {
  return request({
    url: '/user/salary-head/approve',
    method: 'post',
    data: data
  })
}
// 删除工资模板
export function delSalary(data) {
  return request({
    url: '/user/salary-head/delete',
    method: 'post',
    data: data
  })
}
